//Paquetes NPM de GYF. 
import { Mediator } from 'com-gyf-webcore-mediator';
//import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const APLICAR_FILTROS_TARJETAS = 'APLICAR_FILTROS_TARJETAS';
export const GET_TARJETAS_DELIVERY = 'GET_TARJETAS_DELIVERY';
export const RECEIVE_TARJETAS_DELIVERY = 'RECEIVE_TARJETAS_DELIVERY ';
export const RECEIVE_TARJETAS_DELIVERY_FAILURE = 'RECEIVE_TARJETAS_DELIVERY_FAILURE';
export const TOGGLE_CHECK_ALL_ROWS = 'TOGGLE_CHECK_ALL_ROWS';
export const TOGGLE_CHECK_ROW = 'TOGGLE_CHECK_ROW';
export const TOGGLE_TARJETA_CHECKED = 'TOGGLE_TARJETA_CHECKED';
export const TOGGLE_PIN_CHECKED = 'TOGGLE_PIN_CHECKED';
export const TOGGLE_CHECK_TIPO_FILTER = 'TOGGLE_CHECK_TIPO_FILTER';
export const FILTER_BY_ESTADO = 'FILTER_BY_ESTADO';
export const SEARCH_BY_VALUE = 'SEARCH_BY_VALUE';
export const CAMBIAR_ESTADO_PRODUCTOS = 'CAMBIAR_ESTADO_PRODUCTOS';
export const CAMBIAR_ESTADO_PRODUCTOS_FINISHED = 'CAMBIAR_ESTADO_PRODUCTOS_FINISHED';
export const RECEIVE_ESTADOS_DELIVERY = 'RECEIVE_ESTADOS_DELIVERY';
export const RECEIVE_ESTADOS_SIGUIENTES_DELIVERY = 'RECEIVE_ESTADOS_SIGUIENTES_DELIVERY';
export const RECEIVE_TIPOS_PLASTICO = 'RECEIVE_TIPOS_PLASTICO';
export const RECEIVE_FECHAS_PROCESO = 'RECEIVE_FECHAS_PROCESO';
export const FILTRAR_FECHA_PROCESO = 'FILTRAR_FECHA_PROCESO';
export const GET_FUNCIONES_TARJETAS_DELIVERY = 'GET_FUNCIONES_TARJETAS_DELIVERY';
export const GET_FUNCIONES_TARJETAS_DELIVERY_RESULT = 'GET_FUNCIONES_TARJETAS_DELIVERY_RESULT';
export const GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS = 'GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS';
export const GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS_RESULT = 'GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS_RESULT';
export const GET_PERFIL_TARJETAS_DELIVERY = 'GET_PERFIL_TARJETAS_DELIVERY';
export const GET_PERFIL_TARJETAS_DELIVERY_RESULT = 'GET_PERFIL_TARJETAS_DELIVERY_RESULT';
export const PLASTICOS_DELIVERY_FILTRO = 'PLASTICOS_DELIVERY_FILTRO';
export const INICIAR_PLASTICOS_DELIVERY_FILTRO = 'INICIAR_PLASTICOS_DELIVERY_FILTRO';

export const CAMBIAR_RANGO_PAGINA = 'CAMBIAR_RANGO_PAGINA';
let _dispatch;

/**
 * Aplica los filtros existentes para tarjetas.
*  TODO: fijarse si esta funcion se esta usando en algún lado.
 */
export function aplicarFiltros() {

    return (dispatch, getState) => {
        dispatch({ type: APLICAR_FILTROS_TARJETAS });
    }
}


/** 
 * Action que obtiene las funciones (permisos) para el scope actual (usuario/producto/programa).
 * @param {any} currentScope - scope actual para el que obtener las acciones.
 */
export function getPerfilByUserId(currentScope) {
    //LogHelper.In(getScreenData.name, state, currentScope);
    return (dispatch, getState) => {

        dispatch({ type: GET_PERFIL_TARJETAS_DELIVERY });

        const params = { "USUARIO_ID": currentScope.UserId };

        _dispatch = dispatch;

        //CONCIERGE
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_PERFIL_USUARIO', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
        Engine1Proxy.Execute((data) => loadPerfil(data, dispatch), null, null, "DELIVERY");
    }
}


function getEstadosSiguientesDelivery(perfilUsuario, dispatch) {

    const params = { "PerfilId": perfilUsuario };

    //CONCIERGE
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_ESTADOS_SIGUIENTES_DELIVERY', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
    Engine1Proxy.Execute((data) => loadEstadosSiguientesDelivery(data, dispatch), null, null, "DELIVERY");
}


/** 
 * Action que obtiene las funciones (permisos) para el scope actual (usuario/producto/programa).
 * @param {any} currentScope - scope actual para el que obtener las acciones.
 */
export function getPermisosPantalla(currentScope) {
    //LogHelper.In(getScreenData.name, state, currentScope);
    return (dispatch, getState) => {

        dispatch({ type: GET_FUNCIONES_TARJETAS_DELIVERY });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => loadDeliveryTarjetasFunctions(data, dispatch), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Obtiene las sucursales para un ID de usuario determinado.
 * @param {any} usuarioId
 */
export function getSucursalesByUsuario(usuarioId) {

    return (dispatch, getState) => {

        dispatch({ type: GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS });

        let parametrosSucursal = {
            USUARIO_ID: usuarioId
        }

        Engine1Proxy.AddDataSourcesRequests(parametrosSucursal, 'GET_SUCURSAL_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'Product');
        Engine1Proxy.Execute((data) => loadSucursalUsuario(data, dispatch), null, null, "DELIVERY");

    }
}

export function getDatosDelivery() {
    return (dispatch, getState) => {
        Engine1Proxy.AddDataSourcesRequests({}, 'GET_FECHAS_PROCESOS', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
        Engine1Proxy.Execute((data) => getDatosDeliveryAfterProces(data, dispatch), null, null, "DELIVERY");
    }
}

/**
 * Carga los datos iniciales de la pantalla de delivery.
 * Llama a los siguientes data sources:
 *  - GET_PLASTICOS_DELIVERY: Obtiene todos los plásticos cuyo estado no sea "PENDIENTE".
 *  - GET_ESTADOS_DELIVERY: Obtiene los estados posibles de delivery.
 *  - GET_ESTADOS_SIGUIENTES_DELIVERY: Obtiene el workflow de los estados posibles (anterior y siguiente para cada estado).
 *  - GET_TIPOS_PLASTICO: Obtiene los tipos de plástico mostrados (TARJETA DEBITO, TARJETA CREDITO, PIN NUEVO, PIN REIMPRESIÓN,etc...).
 */
function getDatosDeliveryAfterProces(data) {
    //LogHelper.In(getDatosDelivery.name);

    _dispatch({ type: GET_TARJETAS_DELIVERY });

    Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSALES_DELIVERY', 'Get', 'Tarjetas', 'Delivery', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests({}, 'GET_ESTADOS_DELIVERY', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests({}, 'GET_TIPOS_PLASTICO', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
    //Engine1Proxy.AddDataSourcesRequests({}, 'GET_FECHAS_PROCESOS', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');

    const parsedFechasProceso = JSON.parse(data.GET_FECHAS_PROCESOS);
    const fechasProceso = parsedFechasProceso.Recordset0.Rows;

    //let param = {
    //    TIPO: null,
    //    TEXT_FILTER: null,
    //    ESTADO: null,
    //    NRO_PROCESO: fechasProceso != undefined ? fechasProceso[0].Id : -1,
    //}

    //Engine1Proxy.AddDataSourcesRequests(param, 'GET_PLASTICOS_DELIVERY_FILTRO', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');

    Engine1Proxy.Execute((data) => loadDatosTarjetas(data, _dispatch), null, fechasProceso, "DELIVERY");

    //LogHelper.Out(getDatosDelivery.name);
}

export function filterByFechaProceso(proceso) {
    return (dispatch, getState) => {
        // dispatch({ type: APLICAR_FILTROS_TARJETAS });        
        dispatch({ type: FILTRAR_FECHA_PROCESO, id: proceso.id });
    }
}

/*
 * Marca o desmarca todas las filas.
 */
export function toggleCheckAll() {
    //LogHelper.In(toggleCheckAll.name);

    return (dispatch, getState) => {
        dispatch({ type: TOGGLE_CHECK_ALL_ROWS });
    }

    //LogHelper.Out(toggleCheckAll.name);
}

/** 
 * @param {any} tipos
 */
export function toggleCheckTipo(tipos) {
    //LogHelper.In(toggleCheckAll.name);

    return (dispatch, getState) => {
        dispatch({ type: TOGGLE_CHECK_TIPO_FILTER, estadosToFilter: tipos });
    }

    //LogHelper.Out(toggleCheckAll.name);  
}

/**
 * Marca o desmarca una fila en particular.
 * @param {any} row - La fila a marcar/desmarcar.
 */
export function toggleCheckedRow(row) {
    //LogHelper.In(toggleCheckedRow.name, row);

    return (dispatch, getState) => {
        dispatch({ type: TOGGLE_CHECK_ROW, row: row });
    }

    //LogHelper.Out(toggleCheckedRow.name, row);
}

/**
 * Filtra los plásticos por un estado dado.
 * @param {any} value - El estado por el cual filtrar.
 */
export function filterByEstado(value) {
    //LogHelper.In(filterByEstado.name, value);

    return (dispatch, getState) => {
        dispatch({ type: FILTER_BY_ESTADO, estado: value });
    }

    //LogHelper.Out(filterByEstado.name, value);
}

/**
 * Filtra los plásticos por un texto dado.
 * @param {any} value - El texto por el cual filtrar. 
 */
export function searchInTable(value, state) {
    //LogHelper.In(searchInTable.name, value, state);

    return (dispatch, getState) => {
        dispatch({ type: SEARCH_BY_VALUE, value: value });

    }

    //LogHelper.Out(searchInTable.name, value, state);
}

/**
 * Cambia un conjunto de productos a un estado dado.
 * @param {any} productos - Grupo de productos a cambiar.
 * @param {any} estado - Estado al cual cambiar los productos.
 */
export function cambiarEstadoProductos(productos, estado) {
    //LogHelper.In(cambiarEstadoProductos.name, productos, estado);

    return (dispatch, getState) => {

        // TODO: cambiar esto. ids tienen que ser 
        const idsMapeadas = productos.map(p => { return p.id });
        let idsACambiar = "";
        let index = 0;

        for (var id of idsMapeadas) {
            idsACambiar += id.toString();

            if (index < (idsMapeadas.length - 1))
                idsACambiar += ",";

            index++;
        }

        const params = {
            'IDS_A_CAMBIAR': idsACambiar,
            'ESTADO': estado.toString()
        };

        Engine1Proxy.AddRuleRequests(params, 'CambiarEstadoPlasticos', 'Tarjetas', 'Delivery');
        Engine1Proxy.Execute(() => cambiarDatosProductosFinished(productos, estado, dispatch), null, null, "SEGURIDAD");

        dispatch({ type: CAMBIAR_ESTADO_PRODUCTOS });
    }

    //LogHelper.Out(cambiarEstadoProductos.name, productos, estado);
}

export function RealziarBusquedaProductoFiltrada(state) {
    //LogHelper.In(RealziarBusquedaProductoFiltrada.name);

    return (dispatch, getState) => {

        //const state = getState();


        let tipoProductoId = state.tiposChecked;
        let textFilter = state.searchFilter == '' ? null : state.searchFilter;
        let estadoDesc = state.estadoFilter == '' ? null : state.estadoFilter;
        let procesoId = state.procesoSeleccionado == -1 ? null : state.procesoSeleccionado;

        if (tipoProductoId.length == 1) {
            tipoProductoId = tipoProductoId[0].Id;
        }
        else if (tipoProductoId.length == 2) {
            tipoProductoId = null;
        }

        if (state.tiposChecked.length > 0) {

            //_dispatch({ type: INICIAR_PLASTICOS_DELIVERY_FILTRO });

            let param = {
                TIPO: tipoProductoId,
                TEXT_FILTER: textFilter,
                ESTADO: estadoDesc,
                NRO_PROCESO: procesoId
            }

            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PLASTICOS_DELIVERY_FILTRO', 'Get', 'Tarjetas', 'DELIVERY', 1, 'Product');
            Engine1Proxy.Execute((data) => resultRealziarBusquedaProductoFiltrada(data), null, null, "DELIVERY");
        }
    }
    //LogHelper.Out(RealziarBusquedaProductoFiltrada.name);
}

export function cambiarRangoPagina(paginaIndex) {
    return (dispatch, getState) => {
        _dispatch({ type: CAMBIAR_RANGO_PAGINA, paginaIndex: paginaIndex });
    }
    
}

/* -------------------------------------- FUNCIONES AUXILIARES ----------------------------------- */

function resultRealziarBusquedaProductoFiltrada(data) {

    const parsedData = JSON.parse(data.GET_PLASTICOS_DELIVERY_FILTRO);
    const tarjetasData = parsedData.Recordset0.Rows;

    _dispatch({ type: PLASTICOS_DELIVERY_FILTRO, data: tarjetasData });
}

function loadDatosTarjetas(data, dispatch) {
    //LogHelper.In(loadDatosTarjetas.name, data, dispatch);

    //const parsedData = JSON.parse(data.GET_PLASTICOS_DELIVERY_FILTRO);
    //const tarjetasData = parsedData.Recordset0.Rows;

    dispatch({ type: RECEIVE_TARJETAS_DELIVERY, /*data: tarjetasData,*/ sucursales: JSON.parse(data['GET_SUCURSALES_DELIVERY']).Recordset0.Rows });

    const parsedEstados = JSON.parse(data.GET_ESTADOS_DELIVERY);
    const estadosData = parsedEstados.Recordset0.Rows;
    dispatch({ type: RECEIVE_ESTADOS_DELIVERY, data: estadosData });

    // SETEAR ESTADO TIPOS PRODUCTO 
    const parsedTiposPlastico = JSON.parse(data.GET_TIPOS_PLASTICO);
    const tiposPlastico = parsedTiposPlastico.Recordset0.Rows;
    dispatch({ type: RECEIVE_TIPOS_PLASTICO, data: tiposPlastico });

    // SETEAR ESTADO TIPOS PRODUCTO 
    dispatch({ type: RECEIVE_FECHAS_PROCESO, data: data.CALLER_ID });

    //LogHelper.Out(loadDatosTarjetas.name, data, dispatch);
}

function loadEstadosSiguientesDelivery(data, dispatch) {

    // SETEAR ESTADO SIGUIENTES DE DELIVERY.
    const parsedEstadosSiguientes = parseJSONInfo(data.GET_ESTADOS_SIGUIENTES_DELIVERY);

    dispatch({ type: RECEIVE_ESTADOS_SIGUIENTES_DELIVERY, data: parsedEstadosSiguientes });
}

function cambiarDatosProductosFinished(productos, estado, dispatch) {
    //LogHelper.In(cambiarDatosProductosFinished.name, produtos, estado, dispatch);

    dispatch({ type: CAMBIAR_ESTADO_PRODUCTOS_FINISHED, productos: productos, estado: estado });

    //LogHelper.Out(cambiarDatosProductosFinished.name, produtos, estado, dispatch);
}

function loadDeliveryTarjetasFunctions(data, dispatch) {
    if (data.DELIVERY)
        dispatch({ type: GET_FUNCIONES_TARJETAS_DELIVERY_RESULT, functions: data.DELIVERY });
}

function loadSucursalUsuario(data, dispatch) {
    const sucursal = parseJSONInfo(data.GET_SUCURSAL_BY_USUARIO_ID)[0];
    dispatch({ type: GET_SUCURSAL_USUARIO_DELIVERY_TARJETAS_RESULT, sucursal: sucursal });
}


function loadPerfil(data, dispatch) {
    const parsedData = parseJSONInfo(data.GET_PERFIL_USUARIO)[0];
    dispatch({ type: GET_PERFIL_TARJETAS_DELIVERY_RESULT, data: parsedData.PerfilId });

    getEstadosSiguientesDelivery(parsedData.PerfilId, dispatch);
}

/* UTILS */

function parseJSONInfo(data) {
    return JSON.parse(data).Recordset0.Rows;
}
